import actions from './actions';
import actionsAuth from '../authentication/actions';
import { DataService } from '../../services/http-interceptor.service';
import Cookies from 'js-cookie';
import { removeItem } from '../../utils/localStorageControl';

const {
  setUserData,
} = actions;

const {
  logoutSuccess,
} = actionsAuth;

const userGetData = () => {
  return async (dispatch: (arg0: { type: string; data: any; }) => void) => {
    try {
      const response = await DataService.get('users/me');
      
      if (response.status === 401) {
        await Cookies.remove('logedIn');
        removeItem('access_token');
        removeItem('refresh_token');
        removeItem('user');
        dispatch(logoutSuccess(false));
      } else {
        dispatch(setUserData(response.data));
      }
    } catch (err) {
      console.error('Error fetching user data:', err);
      // En caso de error, también limpiar la sesión
      await Cookies.remove('logedIn');
      removeItem('access_token');
      removeItem('refresh_token');
      removeItem('user');
      dispatch(logoutSuccess(false));
    }
  };
};

export { userGetData };
